export default {
    condicoes: [],
    condicao: {}
}